import * as Sentry from '@sentry/nextjs';
import type { CaptureContext, Severity } from '@sentry/types';

export class SentryService {
  static flush(timeout?: number) {
    return Sentry.flush(timeout);
  }

  static captureMessage(message: string, captureContext?: CaptureContext | Severity) {
    return Sentry.captureMessage(message, captureContext);
  }

  static captureException(exception: any, captureContext?: CaptureContext) {
    return Sentry.captureException(exception, captureContext);
  }
}
